// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0f172a;
  padding: 1rem;
}

.login-card {
  background: #1e293b;
  border: 1px solid #334155;
  border-radius: 16px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 380px;
  text-align: center;
}

.login-title {
  color: #f1f5f9;
  font-size: 1.4rem;
  margin: 0 0 2rem;
}

.login-form {
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  text-align: left;
}

.login-field {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.login-field label {
  color: #94a3b8;
  font-size: 0.875rem;
  font-weight: 500;
}

.login-field input {
  padding: 0.75rem 1rem;
  background: #0f172a;
  border: 1px solid #475569;
  border-radius: 8px;
  color: #f1f5f9;
  font-size: 1rem;
  transition: border-color 0.2s;
}

.login-field input:focus {
  outline: none;
  border-color: #f59e0b;
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);
}

.login-error {
  background: rgba(239, 68, 68, 0.1);
  border: 1px solid #ef4444;
  color: #f87171;
  border-radius: 6px;
  padding: 0.625rem 1rem;
  font-size: 0.875rem;
}

.login-btn {
  padding: 0.875rem;
  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
  margin-top: 0.25rem;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 8px 16px rgba(245, 158, 11, 0.3);
}

.login-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
`, "",{"version":3,"sources":["webpack://./src/components/Login.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB","sourcesContent":[".login-page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0f172a;\n  padding: 1rem;\n}\n\n.login-card {\n  background: #1e293b;\n  border: 1px solid #334155;\n  border-radius: 16px;\n  padding: 2.5rem 2rem;\n  width: 100%;\n  max-width: 380px;\n  text-align: center;\n}\n\n.login-title {\n  color: #f1f5f9;\n  font-size: 1.4rem;\n  margin: 0 0 2rem;\n}\n\n.login-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  text-align: left;\n}\n\n.login-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.login-field label {\n  color: #94a3b8;\n  font-size: 0.875rem;\n  font-weight: 500;\n}\n\n.login-field input {\n  padding: 0.75rem 1rem;\n  background: #0f172a;\n  border: 1px solid #475569;\n  border-radius: 8px;\n  color: #f1f5f9;\n  font-size: 1rem;\n  transition: border-color 0.2s;\n}\n\n.login-field input:focus {\n  outline: none;\n  border-color: #f59e0b;\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1);\n}\n\n.login-error {\n  background: rgba(239, 68, 68, 0.1);\n  border: 1px solid #ef4444;\n  color: #f87171;\n  border-radius: 6px;\n  padding: 0.625rem 1rem;\n  font-size: 0.875rem;\n}\n\n.login-btn {\n  padding: 0.875rem;\n  background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%);\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n  margin-top: 0.25rem;\n}\n\n.login-btn:hover:not(:disabled) {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 16px rgba(245, 158, 11, 0.3);\n}\n\n.login-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
